module.exports = __webpack_public_path__ + "static/media/parrot.95c5884d.m4a";